// extracted by mini-css-extract-plugin
module.exports = {"component":"FormFeedback_component__3E-DJ","icon":"FormFeedback_icon__2CdfO"};